/**
 * Goal horn — one short synthesised blast, generated for this project with
 * ffmpeg (four sine partials + tremolo). No recording, no sample library, no
 * team or league audio. Licence note: /app/memory/GOAL_HORN_LICENCE.md
 *
 * play() resolves when the sound started and REJECTS when the browser blocked
 * autoplay, so a caller can fall back to "play it on the first touch".
 */
const HORN_SRC = '/sounds/goal-horn.mp3';

let el = null;

export const playHorn = () => {
    try {
        if (!el) {
            el = new Audio(HORN_SRC);
            el.preload = 'auto';
        }
        el.currentTime = 0;
        const p = el.play();
        return p && typeof p.then === 'function' ? p : Promise.resolve();
    } catch (_e) {
        return Promise.reject(_e);
    }
};

export default playHorn;
